/****************************************************************IMPORTS*/
/****************************************NPM MODULES*/
import { FC } from "react";
/****************************************************/

/*****************************************INTERFACES*/
import { ISpeed } from "../interfaces";
/****************************************************/
/************************************************************************/


/**********************************************************MATRICE RANGE*/
export const Speed: FC<ISpeed> = ({ speed, setSpeed }) => {
    /*****************************************RETURN TSX*/
    return (
        <div className='range'>
            <label htmlFor="range">Vitesse</label>
            <input onChange={(e): void => setSpeed(Number(e.target.value))} type="range" id="range" min="1" max="10" value={speed} />
        </div>
    );
    /****************************************************/
};
/************************************************************************/